export const dateTimeFormatter = (isoString) => {
  const date = new Date(isoString);

  const optionsDate = {
      day: "2-digit",
      month: "short",
      year: "numeric",
    };
    const optionsTime = {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    };

    const datePart = date.toLocaleDateString("en-GB", optionsDate).split(" ");
    const formattedDate = `${datePart[1]} ${datePart[0]} ${datePart[2]}`; // month day year
    const timePart = date.toLocaleTimeString("en-GB", optionsTime).toUpperCase();

    return `${formattedDate} ${timePart}`;
};
